import { AES, enc } from "crypto-js"
const { VITE_REACT_APP_FF_KEY = '' } = import.meta.env

export const encrypt = (plainJson: any) => {
  return AES.encrypt(JSON.stringify(plainJson), VITE_REACT_APP_FF_KEY).toString();
}

export const decrypt = (encStr: string) => {
  const bytes = AES.decrypt(encStr, VITE_REACT_APP_FF_KEY);
  return JSON.parse(bytes.toString(enc.Utf8));
}